import * as React from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
import { MenuItem } from './menuitem'
import { changeNavigationStack } from '../../actions/navigation'
import { createHubItemId } from '../../lib/utils'
import { activeStackIdSelector } from '../../selectors/navigation'

import '../../sass/mainmenu.scss'
import { RootState } from '../../types/rootstate'
import { Dialog } from '../dialog'
import { parentGetPromise } from '../../lib/zoid-utils'
import { strings } from '../../lib/localization'
import { visibleHubSelector } from '../../selectors/hub'

interface Props {

}

export const MainMenu: React.FC<Props> = ({}) => {
  const [showConfirmDialog, setShowConfirmDialog] = React.useState<boolean>(false)
  const [idAfterConfirm, setIdAfterConfirm] = React.useState<string>(undefined)

  const activeStackId: RootState['navigation']['activeStackId'] = useSelector(activeStackIdSelector)
  const visibleHub: RootState['hub'] = useSelector(visibleHubSelector)

  const dispatch = useDispatch()

  const handleHubItemClick = (hubItem: any) => {
    const newId = createHubItemId(hubItem)
    parentGetPromise('getSessionData', 'active-service').then((data) => {
      if ((data === 'chat-bot' && newId === 'online') || (data === 'chat-online' && newId === 'bot')) {
        setShowConfirmDialog(true)
        setIdAfterConfirm(newId)
      } else {
        dispatch(changeNavigationStack(newId))
      }
    }).catch((err) => {
      console.warn(err)
      dispatch(changeNavigationStack(newId))
    })
  }

  const handleCloseConversationDialogOkClick = () => {
    setShowConfirmDialog(false)
    dispatch(changeNavigationStack(idAfterConfirm))
  }

  const handleCloseConversationDialogCancelClick = () => {
    setShowConfirmDialog(false)
  }

  const hubItems = visibleHub
    .sort((a, b) => a.order - b.order)

  return (
    <>
      {showConfirmDialog && <Dialog
          title={strings.changeConversationTitle}
          cancelText={strings.changeConversationCancel}
          okText={strings.changeConversationOk}
          onOkClick={handleCloseConversationDialogOkClick}
          onCancelClick={handleCloseConversationDialogCancelClick}
        />}

      {hubItems.length > 1 && (
        <div className='mainmenu'>
          <ul>
            {hubItems.map((item) =>
              <MenuItem
                key={item.id}
                onClick={handleHubItemClick}
                isActive={activeStackId === item.id}
                item={item}
              />
            )}
          </ul>
        </div>)}
    </>
  )
}
